module.exports = __webpack_public_path__ + "img/teg.117d7c91.jpg";